import styled from '@emotion/styled'
import React, { memo } from 'react'

export interface Props {
  modalStatus?: boolean
}

export const Contacts = memo(function Contacts({ modalStatus }: Props) {
  return (
    <Container className={modalStatus ? 'open' : undefined}>
      Mare Hotel Savona
    </Container>
  )
})

const Container = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight1};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.875rem;
  font-variation-settings: 'wght' 300;
  line-height: 1.0625rem;
  opacity: 0;
  position: absolute;
  bottom: 4.875rem;
  left: 5vw;
  transition: 0.4s ease-in-out;
  z-index: 2;
  &.open {
    opacity: 1;
    transition-delay: 1.6s;
  }

  @media (max-width: 1439px) {
    display: none;
  }
  @media (max-height: 900px) {
    display: none;
  }
`
